export interface VideoItem {
  id: number;
  title: string;
  slug: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  description: string;
  duration: string;
  quality: string;
  year: number;
  rating: number;
  tags: string[];
  views: number;
  publishDate: string;
}

export const categories = [
  { name: '香蕉视频', slug: 'xiangjiao', icon: 'ri-chat-smile-2-line', color: 'from-yellow-500 to-orange-500' },
  { name: '红桃视频', slug: 'hongtao', icon: 'ri-heart-line', color: 'from-red-500 to-pink-500' },
  { name: '蜜桃视频', slug: 'mitao', icon: 'ri-star-line', color: 'from-pink-400 to-rose-500' },
  { name: '樱桃视频', slug: 'yingtao', icon: 'ri-shining-line', color: 'from-rose-400 to-red-400' },
];

export const videos: VideoItem[] = [
  {
    id: 1,
    title: '流浪地球3：星际征途',
    slug: 'liulang-diqi-3',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20massive%20spaceship%20flying%20through%20colorful%20nebula%2C%20dramatic%20cinematic%20lighting%2C%20deep%20space%20background%20with%20stars%2C%20movie%20poster%20style%2C%20warm%20orange%20and%20gold%20tones%2C%20professional%20film%20poster%20design&width=800&height=450&seq=video-cover-01&orientation=landscape',
    category: '香蕉视频',
    categorySlug: 'xiangjiao',
    description: '太阳急速老化，持续膨胀，100年后吞没地球，300年后太阳系将不复存在。人类面临前所未有的生存危机，各国放下纷争，联合起来共同应对。',
    duration: '148分钟',
    quality: '4K 超清',
    year: 2026,
    rating: 9.2,
    tags: ['科幻', '灾难', '冒险', '国产大片'],
    views: 12500000,
    publishDate: '2026-06-15',
  },
  {
    id: 2,
    title: '长安十二时辰之暗夜追踪',
    slug: 'changan-shiershichen',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20detective%20movie%20poster%2C%20mysterious%20figure%20in%20traditional%20robes%20walking%20through%20lantern-lit%20ancient%20street%20at%20night%2C%20cinematic%20atmosphere%2C%20warm%20red%20and%20gold%20tones&width=800&height=450&seq=video-cover-02&orientation=landscape',
    category: '红桃视频',
    categorySlug: 'hongtao',
    description: '天宝三载，上元节前夕，长安城混入可疑人员。身陷囹圄的张小敬临危受命，与少年名士李必携手在十二时辰内破除隐患。',
    duration: '45分钟/集',
    quality: '1080P 高清',
    year: 2025,
    rating: 8.9,
    tags: ['古装', '悬疑', '历史', '推理'],
    views: 8900000,
    publishDate: '2025-11-20',
  },
  {
    id: 3,
    title: '甜蜜蜜的爱情配方',
    slug: 'tianmimi-aiqing',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20drama%20movie%20poster%2C%20couple%20embracing%20in%20cherry%20blossom%20garden%20with%20soft%20pink%20petals%20falling%2C%20warm%20sunlight%2C%20dreamy%20atmosphere%2C%20sweet%20romantic%20film%20poster&width=800&height=450&seq=video-cover-03&orientation=landscape',
    category: '蜜桃视频',
    categorySlug: 'mitao',
    description: '甜品师林小糖遇到高冷美食评论家顾言，两人在美食与爱情的碰撞中，展开了一段甜到心里的浪漫故事。',
    duration: '120分钟',
    quality: '4K 超清',
    year: 2026,
    rating: 8.5,
    tags: ['爱情', '美食', '都市', '甜宠'],
    views: 6700000,
    publishDate: '2026-02-14',
  },
  {
    id: 4,
    title: '功夫熊猫5：龙之觉醒',
    slug: 'gongfu-xiongmao-5',
    coverImage: 'https://readdy.ai/api/search-image?query=Animated%20kung%20fu%20panda%20movie%20poster%2C%20heroic%20panda%20in%20martial%20arts%20pose%20on%20misty%20mountain%20peak%20with%20ancient%20Chinese%20temple%20background%2C%20epic%20cinematic%20style%2C%20warm%20golden%20and%20green%20tones&width=800&height=450&seq=video-cover-04&orientation=landscape',
    category: '樱桃视频',
    categorySlug: 'yingtao',
    description: '阿宝发现了一个古老的龙族传说，为了守护和平谷，他必须找到传说中的龙之力量，与新的伙伴一起踏上冒险之旅。',
    duration: '105分钟',
    quality: '4K 超清',
    year: 2026,
    rating: 8.8,
    tags: ['动画', '喜剧', '动作', '家庭'],
    views: 15600000,
    publishDate: '2026-03-01',
  },
  {
    id: 5,
    title: '盗墓笔记：秦岭神树',
    slug: 'daomu-biji-qinling',
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20adventure%20movie%20poster%2C%20explorers%20with%20flashlights%20inside%20ancient%20underground%20tomb%20with%20giant%20bronze%20tree%2C%20dark%20atmosphere%20with%20warm%20torch%20light%2C%20thrilling%20cinematic&width=800&height=450&seq=video-cover-05&orientation=landscape',
    category: '香蕉视频',
    categorySlug: 'xiangjiao',
    description: '老痒出狱后找到吴邪，讲述了三年前在秦岭深山的诡异经历。两人一同前往秦岭，探寻传说中的青铜神树之谜。',
    duration: '50分钟/集',
    quality: '1080P 高清',
    year: 2025,
    rating: 8.6,
    tags: ['冒险', '悬疑', '奇幻', '盗墓'],
    views: 10200000,
    publishDate: '2025-08-10',
  },
  {
    id: 6,
    title: '乘风破浪的妈妈们',
    slug: 'chengfeng-polam',
    coverImage: 'https://readdy.ai/api/search-image?query=Inspiring%20Chinese%20drama%20poster%2C%20group%20of%20stylish%20middle-aged%20women%20standing%20confidently%20on%20stage%20with%20spotlights%2C%20modern%20urban%20setting%2C%20empowering%20atmosphere%2C%20warm%20lighting&width=800&height=450&seq=video-cover-06&orientation=landscape',
    category: '红桃视频',
    categorySlug: 'hongtao',
    description: '五位不同年龄段的妈妈决定重新出发，她们组成了一支舞蹈队，在追梦的路上收获了友情、成长与自我价值。',
    duration: '42分钟/集',
    quality: '1080P 高清',
    year: 2026,
    rating: 8.3,
    tags: ['都市', '励志', '家庭', '女性'],
    views: 7800000,
    publishDate: '2026-05-08',
  },
  {
    id: 7,
    title: '大侦探福尔摩斯：东方奇案',
    slug: 'futermos-dongfang',
    coverImage: 'https://readdy.ai/api/search-image?query=Detective%20movie%20poster%20set%20in%201920s%20Shanghai%2C%20elegant%20detective%20in%20trench%20coat%20on%20rainy%20neon-lit%20street%2C%20mysterious%20noir%20atmosphere%2C%20art%20deco%20style&width=800&height=450&seq=video-cover-07&orientation=landscape',
    category: '蜜桃视频',
    categorySlug: 'mitao',
    description: '福尔摩斯受邀来到1920年代的上海，调查一系列离奇的连环案件，东西方推理智慧的碰撞就此展开。',
    duration: '135分钟',
    quality: '4K 超清',
    year: 2026,
    rating: 9.0,
    tags: ['悬疑', '推理', '年代', '国际合作'],
    views: 9800000,
    publishDate: '2026-04-22',
  },
  {
    id: 8,
    title: '山海经：异兽纪元',
    slug: 'shanhaijing-yishou',
    coverImage: 'https://readdy.ai/api/search-image?query=Fantasy%20movie%20poster%20featuring%20mythical%20Chinese%20beasts%20from%20ancient%20legends%2C%20phoenix%20and%20dragon%20flying%20over%20misty%20mountains%2C%20epic%20scale%2C%20vibrant%20colors%2C%20traditional%20Chinese%20painting%20style%20blended%20with%20modern%20CGI&width=800&height=450&seq=video-cover-08&orientation=landscape',
    category: '樱桃视频',
    categorySlug: 'yingtao',
    description: '当代少年意外获得《山海经》古籍，被卷入上古神兽的世界。他必须与异兽结盟，阻止一场毁灭世界的灾难。',
    duration: '130分钟',
    quality: '4K 超清',
    year: 2026,
    rating: 9.1,
    tags: ['奇幻', '神话', '冒险', '特效大片'],
    views: 14200000,
    publishDate: '2026-07-01',
  },
  {
    id: 9,
    title: '我在故宫修文物第二季',
    slug: 'gugong-xiuwenwu-2',
    coverImage: 'https://readdy.ai/api/search-image?query=Documentary%20poster%20showing%20hands%20carefully%20restoring%20ancient%20Chinese%20artifacts%20in%20Forbidden%20City%20workshop%2C%20warm%20natural%20light%20through%20traditional%20wooden%20windows%2C%20artisan%20craftsmanship&width=800&height=450&seq=video-cover-09&orientation=landscape',
    category: '香蕉视频',
    categorySlug: 'xiangjiao',
    description: '纪录片团队深入故宫博物院文保科技部，记录文物修复师们用精湛技艺让千年文物重焕生机的动人故事。',
    duration: '52分钟/集',
    quality: '4K 超清',
    year: 2025,
    rating: 9.5,
    tags: ['纪录片', '文化', '历史', '工匠精神'],
    views: 5600000,
    publishDate: '2025-12-01',
  },
  {
    id: 10,
    title: '仙王的日常生活第三季',
    slug: 'xianwang-richang-3',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20poster%20of%20young%20immortal%20king%20in%20modern%20school%20uniform%20using%20magical%20powers%2C%20colorful%20energy%20effects%2C%20high%20school%20setting%2C%20dynamic%20composition&width=800&height=450&seq=video-cover-10&orientation=landscape',
    category: '红桃视频',
    categorySlug: 'hongtao',
    description: '王令继续在仙术高中过着表面上平凡的生活，但各种奇奇怪怪的事件总是不请自来，他的仙王身份也面临新的挑战。',
    duration: '24分钟/集',
    quality: '1080P 高清',
    year: 2026,
    rating: 9.0,
    tags: ['动漫', '搞笑', '奇幻', '校园'],
    views: 11300000,
    publishDate: '2026-01-15',
  },
  {
    id: 11,
    title: '隐秘的角落：迷雾重生',
    slug: 'yinmi-jiaoluo-2',
    coverImage: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20poster%2C%20dark%20alley%20in%20Chinese%20coastal%20town%20with%20single%20figure%20standing%20under%20dim%20streetlight%2C%20foggy%20atmosphere%2C%20mysterious%20and%20tense%20mood&width=800&height=450&seq=video-cover-11&orientation=landscape',
    category: '蜜桃视频',
    categorySlug: 'mitao',
    description: '新故事新人物，一座沿海小城，三个家庭因为一桩意外卷入漩涡。每个人心中都有隐秘的角落，而真相往往比想象更残酷。',
    duration: '48分钟/集',
    quality: '4K 超清',
    year: 2026,
    rating: 9.3,
    tags: ['悬疑', '犯罪', '家庭', '人性'],
    views: 13500000,
    publishDate: '2026-06-28',
  },
  {
    id: 12,
    title: '美食大冒险：环球寻味',
    slug: 'meishi-damaoxian',
    coverImage: 'https://readdy.ai/api/search-image?query=Food%20adventure%20documentary%20poster%2C%20colorful%20world%20cuisine%20collage%20with%20traveler%20holding%20chopsticks%2C%20vibrant%20food%20photography%2C%20global%20map%20background%2C%20warm%20and%20inviting&width=800&height=450&seq=video-cover-12&orientation=landscape',
    category: '樱桃视频',
    categorySlug: 'yingtao',
    description: '跟随美食达人走遍全球30个国家，探寻世界各地的街头美食与米其林餐厅，用味蕾丈量世界。',
    duration: '38分钟/集',
    quality: '4K 超清',
    year: 2026,
    rating: 9.0,
    tags: ['美食', '旅行', '纪录片', '文化'],
    views: 7200000,
    publishDate: '2026-03-20',
  },
];

export const featuredVideoIds = [1, 4, 8, 11];

export const trendingVideoIds = [3, 7, 10, 5];

export const newestVideoIds = [4, 8, 11, 6];